/**
 * useAuthenticatedFetch - Hook for making authenticated API calls
 * Automatically includes Clerk token in requests when available
 */
import { useAuth } from '@clerk/clerk-react';
import { useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useAuthenticatedFetch = () => {
  const { getToken, isSignedIn } = useAuth();

  const authFetch = useCallback(async (endpoint, options = {}) => {
    const url = endpoint.startsWith('http') ? endpoint : `${API_URL}${endpoint}`;
    
    const headers = {
      ...options.headers,
    };

    // Add auth token if signed in
    if (isSignedIn) {
      try {
        const token = await getToken();
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }
      } catch (error) {
        console.warn('Failed to get auth token:', error);
      }
    }

    const response = await fetch(url, {
      ...options,
      headers,
    });

    return response;
  }, [getToken, isSignedIn]);

  const authFetchJson = useCallback(async (endpoint, options = {}) => {
    const response = await authFetch(endpoint, options);
    
    if (!response.ok) {
      const error = await response.text();
      throw new Error(error || response.statusText);
    }
    
    return response.json();
  }, [authFetch]);

  return { authFetch, authFetchJson };
};

export default useAuthenticatedFetch;
